import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import VNBDto from '../Verteilnetzbetreiber/VNBDto'
import DetailRow from '../../components/StaticDetailList/DetailRow'
import EmailCell from '../../components/StaticDetailList/EmailCell'
import PhoneCell from '../../components/StaticDetailList/PhoneCell'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '../../components/StaticDetailList/StaticDetailList'

export default class VNBStammdaten extends WebComponent {
  static get properties() {
    return {
      verteilnetzbetreiber: {type: VNBDto}
    }
  }

  constructor() {
    super()
  }

  get translationFile() {
    return './views/VNBDetail/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  getTemplate() {
    return html`
      <isceco-title size="medium" text="${this.i18n.translate('vnb.stammdaten.title')}"></isceco-title>
      <eko-static-detail-list .data="${this.getListData()}"></eko-static-detail-list>

      <isceco-title size="medium" text="${this.i18n.translate('vnb.ostral.verantwortlicher.title')}"></isceco-title>
      <eko-static-detail-list .data="${this.getOstralListData()}"></eko-static-detail-list>
    `
  }

  getListData() {
    return [
      new DetailRow(this.i18n.translate('vnb.stammdaten.id'), this.verteilnetzbetreiber.id),
      new DetailRow(this.i18n.translate('vnb.stammdaten.extId'), this.verteilnetzbetreiber.extId),
      new DetailRow(this.i18n.translate('vnb.stammdaten.name'), this.verteilnetzbetreiber.name),
      new DetailRow(this.i18n.translate('vnb.stammdaten.adresse'), this.verteilnetzbetreiber.adresse),
      new DetailRow(this.i18n.translate('vnb.stammdaten.kanton'), this.verteilnetzbetreiber.kanton),
      new DetailRow(this.i18n.translate('vnb.stammdaten.email'), this.verteilnetzbetreiber.email, new EmailCell()),
      new DetailRow(this.i18n.translate('vnb.stammdaten.telefon'), this.verteilnetzbetreiber.telefon, new PhoneCell())
    ]
  }

  getOstralListData() {
    return [
      new DetailRow(this.i18n.translate('vnb.stammdaten.ostral.name'), this.verteilnetzbetreiber.ostralVerantwortlicher),
      new DetailRow(this.i18n.translate('vnb.stammdaten.ostral.email'), this.verteilnetzbetreiber.ostralPersonEmail, new EmailCell()),
      new DetailRow(this.i18n.translate('vnb.stammdaten.ostral.telefon'), this.verteilnetzbetreiber.ostralPersonTelefon, new PhoneCell())
    ]
  }
}

customElements.define('eko-frontend-vnb-detail-stammdaten', VNBStammdaten)
